define((require, exports, module) => {
    'use strict';

    const bytes = require('system/libs/bytes');
    const UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     * @param {number} limit – in bytes
     */
    function UserFileSizeLimitFail(stack, source, limit) {
        // eslint-disable-next-line prefer-rest-params
        UploadFail.apply(this, arguments);

        limit = bytes.toNDigits(limit, 3).value;
        this.message = this.message.replace('{LIMIT}', limit);
    }

    UserFileSizeLimitFail.prototype = Object.assign(
        Object.create(UploadFail.prototype),
        {
            constructor: UserFileSizeLimitFail,
            className: 'UserFileSizeLimitFail',
            radarName: 'fail_{SOURCE}_user-file-size-limit',
            message:
                'Объектное хранилище не позволяет загружать файлы больше {LIMIT}.',
        },
    );

    module.exports = UserFileSizeLimitFail;
});
